/**
 * Keysanity key data — dungeon definitions with key counts and images.
 */
import ForestSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Forest.png';
import FireSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Fire.png';
import WaterSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Water.png';
import ShadowSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Shadow.png';
import SpiritSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Spirit.png';
import BotWSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Botw.png';
import GTGSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_GTG.png';
import FortressSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Fortress.png';
import GanonSmallKey from '@/core/assets/oot/classic/OoT_Small_Key_Model_Ganon.png';
import ForestBossKey from '@/core/assets/oot/classic/OoT_Boss_Key_Model_Forest.png';
import FireBossKey from '@/core/assets/oot/classic/OoT_Boss_Key_Model_Fire.png';
import WaterBossKey from '@/core/assets/oot/classic/OoT_Boss_Key_Model_Water.png';
import ShadowBossKey from '@/core/assets/oot/classic/OoT_Boss_Key_Model_Shadow.png';
import SpiritBossKey from '@/core/assets/oot/classic/OoT_Boss_Key_Model_Spirit.png';
import GanonBossKey from '@/core/assets/oot/classic/OoT_Boss_Key_Model_Ganon.png';

export interface DungeonKeyData {
  dungeon: string;
  nbKeysVanilla: number;
  nbKeysMq: number;
  smallKeyImg: string;
  bossKeyImg: string;
  hasBossKey: boolean;
}

export const DUNGEON_KEYS: DungeonKeyData[] = [
  { dungeon: 'Forest', nbKeysVanilla: 5, nbKeysMq: 6, smallKeyImg: ForestSmallKey, bossKeyImg: ForestBossKey, hasBossKey: true },
  { dungeon: 'Fire', nbKeysVanilla: 8, nbKeysMq: 5, smallKeyImg: FireSmallKey, bossKeyImg: FireBossKey, hasBossKey: true },
  { dungeon: 'Water', nbKeysVanilla: 6, nbKeysMq: 2, smallKeyImg: WaterSmallKey, bossKeyImg: WaterBossKey, hasBossKey: true },
  { dungeon: 'Shadow', nbKeysVanilla: 5, nbKeysMq: 6, smallKeyImg: ShadowSmallKey, bossKeyImg: ShadowBossKey, hasBossKey: true },
  { dungeon: 'Spirit', nbKeysVanilla: 5, nbKeysMq: 7, smallKeyImg: SpiritSmallKey, bossKeyImg: SpiritBossKey, hasBossKey: true },
  { dungeon: 'BotW', nbKeysVanilla: 3, nbKeysMq: 2, smallKeyImg: BotWSmallKey, bossKeyImg: '', hasBossKey: false },
  { dungeon: 'GTG', nbKeysVanilla: 9, nbKeysMq: 3, smallKeyImg: GTGSmallKey, bossKeyImg: '', hasBossKey: false },
  { dungeon: 'Fortress', nbKeysVanilla: 4, nbKeysMq: 4, smallKeyImg: FortressSmallKey, bossKeyImg: '', hasBossKey: false },
  { dungeon: 'Ganon', nbKeysVanilla: 2, nbKeysMq: 3, smallKeyImg: GanonSmallKey, bossKeyImg: GanonBossKey, hasBossKey: true },
];
